import { useTranslation } from 'react-i18next';
import { useMarker } from '../../hooks/useMarkers';
import { useLanguageStore } from '../../store/languageStore';
import { useMarkerStore } from '../../store/markerStore';
import { useCurationStore } from '../../store/curationStore';
import { getMarkerTitle } from '../../utils/markerTitle';

function PinnedPlaceRow({ id, removable }: { id: string; removable: boolean }) {
  const { t } = useTranslation();
  const { data: marker } = useMarker(id);
  const language = useLanguageStore((s) => s.currentLanguage);
  const setSelectedMarker = useMarkerStore((s) => s.setSelectedMarker);
  const togglePin = useCurationStore((s) => s.togglePin);
  // A pinned id that no longer resolves (deleted place, stale link) is silently dropped.
  if (!marker) return null;
  const title = getMarkerTitle(marker, language);
  return (
    <li className="pinned-places__item">
      <button type="button" className="pinned-places__open" onClick={() => setSelectedMarker(id)}>
        {title}
      </button>
      {removable && (
        <button
          type="button"
          className="pinned-places__remove"
          aria-label={`${t('chat.results.unpin')}: ${title}`}
          onClick={() => togglePin(id)}
        >
          ×
        </button>
      )}
    </li>
  );
}

/** The pinned places of the current conversation / open plan. Renders nothing when there are none. */
export default function PinnedPlaces({ removable = true }: { removable?: boolean }) {
  const { t } = useTranslation();
  const ids = useCurationStore((s) => s.pinnedMarkerIds);
  if (ids.length === 0) return null;
  return (
    <section className="pinned-places" aria-label={t('chat.pinned')}>
      <h3 className="pinned-places__title">{t('chat.pinned')}</h3>
      <ul className="pinned-places__list">
        {ids.map((id) => (
          <PinnedPlaceRow key={id} id={id} removable={removable} />
        ))}
      </ul>
    </section>
  );
}
